// src/portals/fan/pages/DiscoverPage/components/creatorPreview/MerchCard.js
import React, { useState } from "react";
import Button from "../../../../../../components/ui/Button";
import CheckoutModal from "../../../../../../components/shared/CheckoutModal";
import Modal from "../../../../../../components/ui/Modal";
import { ShoppingBag, Package } from "lucide-react";

const MerchCard = ({ item }) => {
  const [isCheckoutOpen, setCheckoutOpen] = useState(false);
  const [isDetailOpen, setDetailOpen] = useState(false);
  const itemForCheckout = { ...item, type: "Merch" };

  return (
    <>
      <div 
        className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow flex overflow-hidden cursor-pointer"
        onClick={() => setDetailOpen(true)}
      >
        {/* Product Image */}
        <div className="relative w-24 h-24 flex-shrink-0 bg-slate-100">
          {item.imageUrl ? (
            <img
              src={item.imageUrl}
              alt={item.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-slate-400">
              <Package size={32} />
            </div>
          )}
        </div>

        {/* Product Info */}
        <div className="flex-1 p-3 flex flex-col justify-between min-w-0">
          <div>
            <h3 className="font-bold text-slate-800 text-sm line-clamp-2 mb-1">
              {item.name}
            </h3>
            <p className="text-xs text-slate-500">
              {item.stock > 0 ? `${item.stock} in stock` : "Out of stock"}
            </p>
          </div>
          <div className="flex items-center justify-between mt-2">
            <span className="font-bold text-primary text-sm">
              {item.priceETB.toLocaleString()} ETB
            </span>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setCheckoutOpen(true);
              }}
              size="sm"
              disabled={item.stock === 0}
              className="text-xs px-3 py-1"
            >
              Buy Now
            </Button>
          </div>
        </div>
      </div>

      {/* Product Detail Modal */}
      <Modal
        isOpen={isDetailOpen}
        onClose={() => setDetailOpen(false)}
        title={item.name}
      >
        <div className="space-y-4">
          <div className="w-full h-64 bg-slate-100 rounded-lg overflow-hidden">
            {item.imageUrl ? (
              <img
                src={item.imageUrl}
                alt={item.name}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-slate-400">
                <Package size={64} />
              </div>
            )}
          </div>
          
          <div>
            <h4 className="font-bold text-slate-800 mb-2">Product Details</h4>
            <p className="text-sm text-slate-600">
              {item.description || "High-quality merchandise from your favorite creator."}
            </p>
          </div>

          <div className="flex items-center justify-between py-3 border-t border-slate-200">
            <div>
              <p className="text-xs text-slate-500">Price</p>
              <p className="text-xl font-bold text-primary">{item.priceETB.toLocaleString()} ETB</p>
            </div>
            <div className="text-right">
              <p className="text-xs text-slate-500">Availability</p>
              <p className={`text-sm font-semibold ${item.stock > 0 ? 'text-green-600' : 'text-red-600'}`}>
                {item.stock > 0 ? `${item.stock} in stock` : "Out of stock"}
              </p>
            </div>
          </div>

          <Button
            onClick={() => {
              setDetailOpen(false);
              setCheckoutOpen(true);
            }}
            className="w-full"
            disabled={item.stock === 0}
          >
            <ShoppingBag size={18} className="mr-2" />
            Buy Now
          </Button>
        </div>
      </Modal>

      <CheckoutModal
        isOpen={isCheckoutOpen}
        onClose={() => setCheckoutOpen(false)}
        item={itemForCheckout}
      />
    </>
  );
};

export default MerchCard;
